export class ToggleChangeBlocks {
    constructor(optionalOptions = {}) {
        this._linkbloks = document.querySelectorAll('[data-action=\'toggle\']');

        if (!this._linkbloks) {
            this.destructor();
            return true;
        }

        let showBlock
        let blocks

        this._linkbloks.forEach((button) => {
            button.addEventListener("change", (event) => {
                event.preventDefault()

                showBlock = button.dataset.block

                if (!showBlock) {
                    this.destructor();
                    return false
                }

                blocks = document.querySelectorAll(showBlock);
                if (blocks) {
                    blocks.forEach((block) => {
                        block.classList.toggle('d-none');
                    })
                }

                return false
            })
        })
    }

    destructor() {
        this._linkbloks = null;
    }
}

export default new ToggleChangeBlocks();